import React from 'react';
import { AuthContext } from '../context';
import { useOidcAuth } from './useOidcAuth';
import { AuthProvider } from 'react-oidc-context';
import { oidcUserManager } from './userManager';

interface OidcAuthProviderProperties {
  children: React.ReactNode;
}

const InternalOidcAuthProvider: React.FC<OidcAuthProviderProperties> = ({ children }) => {
  const authService = useOidcAuth();
  return <AuthContext.Provider value={authService}>{children}</AuthContext.Provider>;
};

export const OidcAuthProvider: React.FC<OidcAuthProviderProperties> = ({ children }) => {
  return (
    <AuthProvider userManager={oidcUserManager}>
      <InternalOidcAuthProvider>{children}</InternalOidcAuthProvider>
    </AuthProvider>
  );
};
